import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

const IsUpdatingIndicator = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <i
        className="fa-solid fa-circle-notch fa-spin"
        style={{ fontSize: "1rem" }} // '1x' size corresponds to approximately 1rem
      ></i>
    </div>
  );
};

export default IsUpdatingIndicator;
